import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { LogLicenze as LogLicenzeReducer } from '../../reducers/r_index';
import { FilterLogLicenze as FilterLogLicenzeReducer } from '../../reducers/r_index';

//Components
import GridLogLicenzeCmp from '../../components/log/GridLogLicenzeCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
    detailContainer: {
        margin: '10px',
    },
});

class GridLogLicenze extends Component {

    componentDidMount() {
        if (this.props.codiceUtente !== 'anonymous')
            this.props.getLogLicenze(this.props.codiceUtente);
    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.codiceUtente !== propsPrecedenti.codiceUtente) {
            if (this.props.codiceUtente !== 'anonymous')
                this.props.getLogLicenze(this.props.codiceUtente);
        }
    }

    render() {
        const { ...props } = this.props;

        return (
            <GridLogLicenzeCmp {...props} />
        );

    }
}

GridLogLicenze.propTypes = {
    getLogLicenze: PropTypes.func.isRequired,
    log_licenze: PropTypes.arrayOf(PropTypes.object).isRequired,
    getLogLicenzeRequestStatus: PropTypes.string.isRequired,

    selection: PropTypes.arrayOf(PropTypes.number).isRequired,
    selectedRowIndex: PropTypes.number.isRequired,
    selected_log_licenza: PropTypes.shape({}).isRequired,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    sorting: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
    expandedRowIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    columnWidths: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    onSortingChange: PropTypes.func.isRequired,
    onFiltersChange: PropTypes.func.isRequired,
    onCurrentPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onColumnWidthsChange: PropTypes.func.isRequired,
    handleRowSelection: PropTypes.func.isRequired,
    setSelectedLogLicenza: PropTypes.func.isRequired,

    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};


const mapDispatchToProps = dispatch => ({
    getLogLicenze: (codiceUtente) => { dispatch(LogLicenzeReducer.creators.getLogLicenzeRequest(codiceUtente)); },

    onSortingChange: (sorting) => { dispatch(FilterLogLicenzeReducer.creators.onGridAction('sorting', sorting)) },
    onFiltersChange: (filters) => { dispatch(FilterLogLicenzeReducer.creators.onGridAction('filters', filters)) },
    onCurrentPageChange: (currentPage) => { dispatch(FilterLogLicenzeReducer.creators.onGridAction('currentPage', currentPage)) },
    onPageSizeChange: (pageSize) => { dispatch(FilterLogLicenzeReducer.creators.onGridAction('pageSize', pageSize)) },
    onColumnWidthsChange: (widths) => { dispatch(FilterLogLicenzeReducer.creators.onGridAction('columnWidths', widths)) },
    handleRowSelection: (newSelection) => { dispatch(FilterLogLicenzeReducer.creators.handleRowSelection(newSelection)) },
    setSelectedLogLicenza: (selected_log_licenza) => { dispatch(FilterLogLicenzeReducer.creators.setSelectedLogLicenza(selected_log_licenza)) },
    handleExpandedRow: (newExpandedRowIds) => { dispatch(FilterLogLicenzeReducer.creators.handleExpandedRow(newExpandedRowIds)) },
    resetFilters: () => { dispatch(FilterLogLicenzeReducer.creators.resetFilters()) },
});

const mapStateToProps = state => ({
    log_licenze: state['log-licenze'].log_licenze,
    getLogLicenzeRequestStatus: state['log-licenze'].status,

    selection: state['filtro-log-licenze'].selection,
    selectedRowIndex: state['filtro-log-licenze'].selectedRowIndex,
    selected_log_licenza: state['filtro-log-licenze'].selected_log_licenza,
    filters: state['filtro-log-licenze'].filters,
    sorting: state['filtro-log-licenze'].sorting,
    currentPage: state['filtro-log-licenze'].currentPage,
    pageSize: state['filtro-log-licenze'].pageSize,
    pageSizes: state['filtro-log-licenze'].pageSizes,
    expandedRowIds: state['filtro-log-licenze'].expandedRowIds,
    columnWidths: state['filtro-log-licenze'].columnWidths,

    codiceUtente: state['logged-user'].codiceUtente,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GridLogLicenze));